import React, { useState, useEffect } from 'react';
import styles from './Signup.module.css';
import axios from '../api/axios';
import { NavLink, useLocation } from 'react-router-dom';
import Select from 'react-select';
import Flag from 'react-world-flags';
import Logo from '../assets/zucoinvoiceapplogo.png';
import { ToastContainer, toast } from "react-toastify";

function SignUp() {
  const [plan , setPlan] = useState('');
  const [username, setUserName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [selectedOption, setSelectedOption] = useState(null);
   const [loading, setLoading] = useState(false);
  const [countriesList, setCountriesList] = useState([]);
  const [visible, setVisible] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);
  
const location = useLocation();
  const togglePasswordVisibility = () => setVisible(!visible);
  const toggleConfirmPasswordVisibility = () => setConfirmVisible(!confirmVisible);

  useEffect(() => {
      const params = new URLSearchParams(location.search);
      //const status = params.get("status");
      const planName = params.get("plan");
    if(planName){
      setPlan(planName);
    }
  },[location])

  // ✅ Fetch countries
 
useEffect(() => {
  const fetchCountries = async () => {
    try {
      const response = await fetch(
        "https://api.restcountries.com/countries/v5?response_fields=names.common,codes.alpha_2,flag.emoji&limit=100&offset=100",
      
      { headers: { 'Authorization': 'Bearer rc_live_83c1ee5a25a641a8b00c4e8c0880f1ed' }
     })
    ;

      if (!response.ok) {
        throw new Error(`Failed to fetch countries: ${response.status}`);
      }

      const data = await response.json();
      console.log(data);
      const countryList = data.data.objects
        .map((country) => ({
          code: country.codes?.alpha_2 || "",
          name: country.names?.common || "",
          dial_code: "",
          flag: country.flag?.emoji || "",
        }))
        .filter((country) => country.code && country.name)
        .sort((a, b) => a.name.localeCompare(b.name));

      setCountriesList(countryList);
    } catch (error) {
      console.error("Failed to fetch countries:", error);
    }
  };

  fetchCountries();
}, []);

  // ✅ Map options for react-select
 const options = countriesList.map((country) => ({
  value: country.dial_code,
  label: (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <Flag code={country.code} style={{ width: 50, borderRadius: "3px" }} />
      <span>{country.name}</span>
      <span style={{ marginLeft: "auto", fontWeight: "bold" }}>
        {country.dial_code}
      </span>
    </div>
  ),
  icon: (
    <Flag code={country.code} style={{ width: 30, borderRadius: "3px" }} />
  ), // used for selectedValue
  searchLabel: `${country.name} ${country.dial_code}`,
}));


  const REGISTER_URL = '/api/Auth/AddUser';
   
  const handleSignIn = async (e) => {
    e.preventDefault();
     setLoading(true);
    if (!selectedOption) {
      alert('Please select your country code');
      return;
    }

    const phone = phoneNumber.startsWith('0')
      ? phoneNumber.slice(1)
      : phoneNumber;
    const fullPhone = `${selectedOption.value}${phone}`;

    try {
      const response = await axios.post(REGISTER_URL, {
        email: username,
        phonenumber: fullPhone,
        password,
        confirmPassword,
      });
     
      if (response.status === 200) {
        alert('Registration successful, Please login');
        window.location.href = `/login?plan=${encodeURIComponent(plan)}`;
      } else {
        alert('Registration failed');
      }
    } catch (error) {
      console.error('Register error:', error);
      // alert('Error during registration');
      toast.error("Error during registration! Kindly try again", { position: 'top-right'});
        }
        finally{
          setLoading(false);
    
        }
  };

  return (
    <>
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', marginTop: '30px' }}>
      <NavLink to="/"><img src={Logo} alt="logo" /></NavLink>
      </div>
    
    <div className={styles.signup_container}>
      <div>
        <h2 className={styles.start}>Get Started</h2>
        <p className={styles.start2}>
          Already have an account? <NavLink to="/login">Sign In</NavLink>
        </p>
      </div>

      <form className={styles.signup_form} onSubmit={handleSignIn}>
        <label className={styles.label}>Email Address</label>
        <input
          type="email"
          value={username}
          onChange={(e) => setUserName(e.target.value)}
          placeholder="Email Address"
          required
          className={styles.input}
        />

        <label className={styles.label}>Phone Number</label>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent:'space-between' }}>
         <Select
  options={options}
  value={selectedOption}
  onChange={setSelectedOption}
  placeholder=" "
  isSearchable={true}
  filterOption={(option, input) =>
    option.data.searchLabel.toLowerCase().includes(input.toLowerCase())
  }
  styles={{
    container: (base) => ({
      ...base,
      width: "60px",                 // SMALL compact width
    }),
    control: (base) => ({
      ...base,
      minHeight: "45px",
      borderRadius: "8px",
      borderColor: "#ccc",
      paddingLeft: "4px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }),

    // 🔥 Show ONLY the flag when selected
    singleValue: (base) => ({
      ...base,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 0,
      margin: 0,
    }),

    valueContainer: (base) => ({
      ...base,
      padding: 0,
      margin: 0,
    }),

    indicatorsContainer: (base) => ({
      ...base,
      padding: 0,
      margin: 0,
    }),

    dropdownIndicator: (base) => ({
      ...base,
      padding: 2,
    }),

    menu: (base) => ({
      ...base,
      zIndex: 9999,
      width: "250px", // Bigger dropdown area for clarity
    }),

    // Dropdown item style
    option: (base, state) => ({
      ...base,
      display: "flex",
      alignItems: "center",
      gap: "10px",
      padding: "10px 12px",
      backgroundColor: state.isFocused ? "#f1f1f1" : "white",
      color: "black",
    }),
    
  }}
  formatOptionLabel={(option, { context }) =>
    context === "value" ? option.icon : option.label
  }
/>

          <input
            type="tel"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            placeholder="Enter Phone Number"
            style={{ flex: 1, marginLeft: '10px' }}
            required
            className={styles.input2}
          />
        </div>

        <label className={styles.label}>Password</label>
        <div className={styles.inputWrapper}>
          <input
            type={visible ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
          />
          <i
            className={`material-icons ${styles.icon}`}
            onClick={togglePasswordVisibility}
          >
            {visible ? 'visibility' : 'visibility_off'}
          </i>
        </div>

        <label className={styles.label}>Confirm Password</label>
        <div className={styles.inputWrapper}>
          <input
            type={confirmVisible ? 'text' : 'password'}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm Password"
            required
          />
          <i
            className={`material-icons ${styles.icon}`}
            onClick={toggleConfirmPasswordVisibility}
          >
            {confirmVisible ? 'visibility' : 'visibility_off'}
          </i>
        </div>

        <p className={styles.underlay}>
          By creating an account, you agree to our{' '}
          <span>Terms and Conditions</span>
        </p>
            {loading && <div className={styles.spinner}></div>}                    
                      
        <button type="submit" className={styles.createaccount}>
          Create Account
        </button>
      </form>
    </div>
    <ToastContainer/>
    </>
  );
}

export default SignUp;
